import { MessageCircle, UserCheck, Play } from 'lucide-react'

export const HowItWorksSection = () => {
  return (
    <section
      id="how-it-works"
      className="py-20 bg-gradient-to-br from-blue-50 to-green-50"
    >
      <div className="container px-4 md:px-6 mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-super-text mb-4">
            Como funciona?
          </h2>
          <p className="text-muted-foreground">
            Simples, rápido e pensado para a sua comodidade.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-slate-200 -z-10" />

          {/* Step 1 */}
          <div className="flex flex-col items-center text-center space-y-4">
            <div className="w-24 h-24 rounded-full bg-white border-4 border-super-green flex items-center justify-center shadow-lg mb-2 relative z-10">
              <MessageCircle className="h-10 w-10 text-super-green" />
              <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-super-text text-white flex items-center justify-center font-bold">
                1
              </div>
            </div>
            <h3 className="text-xl font-bold text-super-text">
              Você chama no WhatsApp
            </h3>
            <p className="text-slate-600 max-w-xs">
              Clique no botão e fale direto com a gente.
            </p>
          </div>

          {/* Step 2 */}
          <div className="flex flex-col items-center text-center space-y-4">
            <div className="w-24 h-24 rounded-full bg-white border-4 border-super-blue flex items-center justify-center shadow-lg mb-2 relative z-10">
              <UserCheck className="h-10 w-10 text-super-blue" />
              <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-super-text text-white flex items-center justify-center font-bold">
                2
              </div>
            </div>
            <h3 className="text-xl font-bold text-super-text">
              Indicamos a melhor modalidade e horários
            </h3>
            <p className="text-slate-600 max-w-xs">
              Conversamos para entender o que seu filho precisa.
            </p>
          </div>

          {/* Step 3 */}
          <div className="flex flex-col items-center text-center space-y-4">
            <div className="w-24 h-24 rounded-full bg-white border-4 border-super-yellow flex items-center justify-center shadow-lg mb-2 relative z-10">
              <Play className="h-10 w-10 text-super-yellow ml-1" />
              <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-super-text text-white flex items-center justify-center font-bold">
                3
              </div>
            </div>
            <h3 className="text-xl font-bold text-super-text">
              Seu filho começa e evolui brincando
            </h3>
            <p className="text-slate-600 max-w-xs">
              Diversão e desenvolvimento garantidos!
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
